import React, { Component } from 'react';
import { USER_ROLES, SuccessMessages } from 'src/common/constants';
import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import FontAwesomeIcon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from '../Table';
import Search from '../Search';
import {
  setSuiteFormData,
  clearSuiteFormData,
} from 'src/store/actions/suiteForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectSearch } from 'src/store/selectors/search';
import { onEventScheduled } from 'src/store/actions/contacts';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import {
  setPropertyWalkThroughFormIsVisible,
  setPropertyWalkThroughFormData,
  setPropertyWalkThroughFormStep,
  fetchConfigureTypeWalkThroughData,
} from 'src/store/actions/propertyWalkThroughForm';
import { selectPropertyWalkThroughFormIsVisible } from 'src/store/selectors/propertyWalkThroughForm';
import {
  setEasyWalkThroughFormData,
  exitEasyWalkThroughForm,
  fetchWalkThroughServiceList,
} from 'src/store/actions/easyWalkThroughForm';
import { exitPropertyWalkThroughForm } from 'src/store/actions/propertyWalkThroughForm';
import { fetchAreasAndSubAreas } from 'src/store/actions/areas';
import { fetchAssetsBySuiteId } from 'src/store/actions/assets';
import { fetchCalendlyLink } from 'src/store/actions/auth';
import Loader from '../Loader';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import { setWalkThroughStatus } from 'src/store/actions/suites';
import { fetchAllIssueTypes } from 'src/store/actions/formOptions';
import { variables } from 'src/Tenants';
import './walkThroughTable.scss';
import 'reactjs-popup/dist/index.css';
import { ScheduleWalkthroughComponent } from '../ScheduleWalkthrough/ScheduleWalktroughComponent';
import {
  onWalkthroughScheduled,
  onDeleteWalkthrough,
} from 'src/store/actions/walkThroughs';
import { fetchPropertyDeveloperAvailableTimes } from 'src/store/actions/availableServiceTimes';
import moment from 'moment';
import { startFormLoading, stopFormLoading } from 'src/store/actions/loader';
import { downloadDocument } from 'src/helpers/DownloadDoc';
import AddWalkthrough from '../PropertyWalkThroughForm/AddWalkthrough';
import {
  onCheckUserCanAccessTheModule,
  ToastInfo,
} from 'src/helpers/validationHelper';
import { scheduleWalkthrough } from 'src/helpers/eventSchedulingHelper';
import { SimplifiedStatusButton, StatusButton } from './statusButton';

class WalkThroughTable extends Component {
  state = {
    showOverlay: false,
    activatedOptions: ['Guided Walk Through', 'Self-Guided Walk Through'],
    isEventShow: false,
    suiteData: {},
    scheduling_url: '',
    scheduled: false,
    openModal: false,
    activateData: null,
    activateStatus: '',
    notes: '',
    addWalkthroughVisible: false,
    walkthroughSelectedObj: {},
  };

  componentDidMount() {
    const { onFetchAllIssueTypes, stopFormLoading } = this.props;
    onFetchAllIssueTypes();
    stopFormLoading();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };
  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        openModal: false,
        activateStatus: 'Select Walk Through Type',
      });
    }
  };

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  eventScheduled(date) {
    const { suiteData, suiteWalkthrough } = this.state;
    const {
      onEventScheduled,
      user,
      property,
      setWalkThroughStatus,
      suites,
      suite,
    } = this.props;

    if (suiteWalkthrough && suiteWalkthrough.id) {
      let params = {
        WalkthroughId: suiteWalkthrough.id,
        PropertymanagerId:
          property.propertyManager && property.propertyManager.id
            ? property.propertyManager.id
            : '',
        UserId: user.id,
        Timestamp: date,
      };
      setTimeout(() => this.setState({ isEventShow: false }), 3000);
      onEventScheduled(params);
      let status = {
        walkthroughType: suiteWalkthrough.walkthroughType,
        WalkthroughId: suiteWalkthrough.id,
        SuiteId: suiteData.id,
        UserId: user.id,
        Role: user.roles[0].role.name,
        Signature: '',
        Status: 'Begin',
        PropertyName: property.name,
        SuiteName: suiteData.number,
        PropertymanagerId:
          property.propertyManager && property.propertyManager.id
            ? property.propertyManager.id
            : '',
        ActionUrl: 'app/suites/' + property.id + '&' + suiteData.id,
      };
      let suite = suiteData;
      suite = { ...suite, status: 'Begin' };
      setWalkThroughStatus(status, suite);
    } else {
      let filteredSuites = suites.filter(
        (suite) => suite.homeownerId === this.props.user.id
      );
      if (filteredSuites.length > 0) {
        let params = {
          WalkthroughId: suiteWalkthrough.id,
          PropertymanagerId:
            property.propertyManager && property.propertyManager.id
              ? property.propertyManager.id
              : '',
          UserId: user.id,
          Timestamp: date,
        };
        setTimeout(
          () => this.setState({ isEventShow: false, scheduled: true }),
          3000
        );
        onEventScheduled(params);
        let status = {
          walkthroughType: suiteWalkthrough.walkthroughType,
          WalkthroughId: suiteWalkthrough.id,
          SuiteId: suiteData.id,
          UserId: user.id,
          Role: user.roles[0].role.name,
          Signature: '',
          Status: 'Begin',
          PropertyName: property.name,
          SuiteName: suiteData.number,
          PropertymanagerId:
            property.propertyManager && property.propertyManager.id
              ? property.propertyManager.id
              : '',
          ActionUrl: 'app/suites/' + property.id + '&' + suiteData.id,
        };

        let suite = filteredSuites[0];
        suite = { ...suite, status: 'Begin' };
        setWalkThroughStatus(status, suite);
      }
    }
  }

  handleStatusClicked(data) {
    const {
      suite,
      user,
      onSetPropertyWalkThroughFormIsVisible,
      onSetPropertyWalkThroughFormData,
      property,
      onSetPropertyWalkThroughFormStep,
      onFetchConfigureTypeWalkThroughData,
      onFetchAreasAndSubAreas,
      onSetEasyWalkThroughFormData,
    } = this.props;
    const roleName = user.roles[0].role.name;
    if (data.status === 'Review' && roleName === 'Realtor') {
      // show mobile app overlay
    } else {
      if (roleName !== 'Realtor') {
        if (suite.areas.length > 0) {
          if (data.status !== 'Activate') {
            onSetPropertyWalkThroughFormData({
              walkthroughType: data.walkthroughType,
              propertyId: property.id,
              propertyManagerId: property.propertyManagerId,
              propertyName: property.name,
              suiteId: suite.id,
              suiteName: variables.Suite + ' ' + suite.number,
              assetWarrantyDefaultStartDate: suite.assetWarrantyDefaultStartDate
                ? suite.assetWarrantyDefaultStartDate
                : null,
              status: data.status,
              walkthroughId: data.id ? data.id : '',
              propertyAddress: property.addressLine1,
              propertyCity: property.city,
              propertyProvince: property.province,
              proeprtyPostalCode: property.postalCode,
              isHomeOwner:
                suite.homeOwners && suite.homeOwners.id ? true : false,
            });
          }

          if (
            data.walkthroughType === 'Simplified' ||
            data.walkthroughType === 'Developer Walk-through' ||
            data.walkthroughType === 'Construction Walk-through'
          ) {
            onSetPropertyWalkThroughFormData({
              permissions: data.permissions ? data.permissions : null,
              walkthroughName: data.walkthroughName,
            });
            onSetEasyWalkThroughFormData({
              homeOwnerFirstName:
                suite && suite.homeOwners && suite.homeOwners.firstname
                  ? suite.homeOwners.firstname
                  : suite.firstName
                    ? suite.firstName
                    : '',
              homeOwnerLastName:
                suite && suite.homeOwners && suite.homeOwners.lastname
                  ? suite.homeOwners.lastname
                  : suite.lastName
                    ? suite.lastName
                    : '',
              propertyManagerFirstName:
                user &&
                user.roles.length > 0 &&
                (user.roles[0].role.name === 'Property Developer' ||
                  user.roles[0].role.name === 'Admin')
                  ? user.firstname
                  : property.propertyManager &&
                      property.propertyManager.firstname
                    ? property.propertyManager.firstname
                    : '',
              propertyManagerLastName:
                user &&
                user.roles.length > 0 &&
                (user.roles[0].role.name === 'Property Developer' ||
                  user.roles[0].role.name === 'Admin')
                  ? user.lastname
                  : property.propertyManager &&
                      property.propertyManager.lastname
                    ? property.propertyManager.lastname
                    : '',
            });
            if (data.status === 'Schedule') {
              if (
                onCheckUserCanAccessTheModule([
                  USER_ROLES.HOME_OWNER,
                  USER_ROLES.OCCUPANT,
                ])
              ) {
                this.setState({
                  showOverlay: true,
                  walkthroughSelectedObj: data,
                });
              }
            } else if (
              data.status === 'Begin' &&
              onCheckUserCanAccessTheModule([
                USER_ROLES.HOME_OWNER,
                USER_ROLES.OCCUPANT,
              ]) &&
              data?.schedule
            ) {
              this.setState({
                showOverlay: true,
                walkthroughSelectedObj: data,
              });
            } else {
              if (data.status === 'Review') {
                onSetPropertyWalkThroughFormIsVisible(true);
                onSetPropertyWalkThroughFormStep(5);
                onSetEasyWalkThroughFormData({
                  reviewWalkThroughServiceRequestListLoading: true,
                  walkThroughId: data.id,
                });
              } else if (data.status === 'Activate') {
              } else {
                // if status is self-guided walkthrough what the status we have to update after open the walkthrough
                if (
                  data.status === 'Begin' ||
                  (onCheckUserCanAccessTheModule([
                    USER_ROLES.HOME_OWNER,
                    USER_ROLES.OCCUPANT,
                  ]) &&
                    data.status === 'Self-Guided Walk Through')
                ) {
                  let status = {
                    WalkthroughId: data.id,
                    Status:
                      data.status === 'Begin'
                        ? 'In Progress'
                        : 'In Progress Home Only',
                    SuiteId: data.suiteId,
                  };
                }
                onSetPropertyWalkThroughFormIsVisible(true);
                onSetPropertyWalkThroughFormStep(4);
              }
            }
          } else if (
            data.walkthroughType === 'Enhanced' ||
            data.walkthroughType === 'Home Owner Walk-through'
          ) {
            onSetPropertyWalkThroughFormData({
              permissions: data.permissions ? data.permissions : null,
              walkthroughName: data.walkthroughName,
            });
            if (data.status === null || data.status === 'Configure') {
              if (
                !onCheckUserCanAccessTheModule([
                  USER_ROLES.HOME_OWNER,
                  USER_ROLES.OCCUPANT,
                ])
              ) {
                onFetchAreasAndSubAreas(data.id);
                onSetPropertyWalkThroughFormIsVisible(true);
                onSetPropertyWalkThroughFormStep(0);
                onFetchConfigureTypeWalkThroughData(data.id, true);
              }
            } else if (data.status === 'In Progress') {
              if (
                !onCheckUserCanAccessTheModule([
                  USER_ROLES.HOME_OWNER,
                  USER_ROLES.OCCUPANT,
                ])
              ) {
                onFetchAreasAndSubAreas(data.id);
                onSetPropertyWalkThroughFormIsVisible(true);
                onSetPropertyWalkThroughFormStep(1);
                onSetEasyWalkThroughFormData({
                  homeOwnerFirstName:
                    suite && suite.homeOwners && suite.homeOwners.firstname
                      ? suite.homeOwners.firstname
                      : suite.firstName
                        ? suite.firstName
                        : '',
                  homeOwnerLastName:
                    suite && suite.homeOwners && suite.homeOwners.lastname
                      ? suite.homeOwners.lastname
                      : suite.lastName
                        ? suite.lastName
                        : '',
                  propertyManagerFirstName:
                    roleName === 'Property Developer' || roleName === 'Admin'
                      ? user.firstname
                      : property.propertyManager &&
                          property.propertyManager.firstname
                        ? property.propertyManager.firstname
                        : '',
                  propertyManagerLastName:
                    roleName === 'Property Developer' || roleName === 'Admin'
                      ? user.lastname
                      : property.propertyManager &&
                          property.propertyManager.lastname
                        ? property.propertyManager.lastname
                        : '',
                });
                onFetchConfigureTypeWalkThroughData(data.id, true);
              }
            } else if (data.status === 'Activate') {
            } else if (data.status === 'Schedule') {
              if (
                onCheckUserCanAccessTheModule([
                  USER_ROLES.HOME_OWNER,
                  USER_ROLES.OCCUPANT,
                ])
              ) {
                this.setState({
                  showOverlay: true,
                  walkthroughSelectedObj: data,
                });
              }
            } else if (
              data.status === 'Begin' &&
              onCheckUserCanAccessTheModule([
                USER_ROLES.HOME_OWNER,
                USER_ROLES.OCCUPANT,
              ]) &&
              data?.schedule
            ) {
              this.setState({
                showOverlay: true,
                walkthroughSelectedObj: data,
              });
            } else {
              onSetEasyWalkThroughFormData({
                homeOwnerFirstName:
                  suite && suite.homeOwners && suite.homeOwners.firstname
                    ? suite.homeOwners.firstname
                    : suite.firstName
                      ? suite.firstName
                      : '',
                homeOwnerLastName:
                  suite && suite.homeOwners && suite.homeOwners.lastname
                    ? suite.homeOwners.lastname
                    : suite.lastName
                      ? suite.lastName
                      : '',
                propertyManagerFirstName:
                  user &&
                  user.roles.length > 0 &&
                  (user.roles[0].role.name === 'Property Developer' ||
                    user.roles[0].role.name === 'Admin')
                    ? user.firstname
                    : property.propertyManager &&
                        property.propertyManager.firstname
                      ? property.propertyManager.firstname
                      : '',
                propertyManagerLastName:
                  user &&
                  user.roles.length > 0 &&
                  (user.roles[0].role.name === 'Property Developer' ||
                    user.roles[0].role.name === 'Admin')
                    ? user.lastname
                    : property.propertyManager &&
                        property.propertyManager.lastname
                      ? property.propertyManager.lastname
                      : '',
              });
              if (data.status === 'Review') {
                onSetPropertyWalkThroughFormIsVisible(true);
                onSetPropertyWalkThroughFormStep(3);
                onSetEasyWalkThroughFormData({
                  reviewWalkThroughServiceRequestListLoading: true,
                  walkThroughId: data.id,
                });
              } else {
                onSetPropertyWalkThroughFormIsVisible(true);
                onSetPropertyWalkThroughFormStep(2);
              }
            }
          }
        } else {
          alert(
            `No Areas/Rooms found for the sutie, Please Add Areas/Rooms to this ${variables.suite} !`
          );
        }
      }
    }
  }

  activate(e, data) {
    let statusToSet = '';
    if (e.target.value === 'Guided Walk Through') {
      statusToSet = 'Schedule';
    } else statusToSet = e.target.value;
    const {
      property,
      suite,
      user,
      setWalkThroughStatus,
      fetchSuiteWalkThroughs,
    } = this.props;
    let status = {
      WalkthroughId: data.id,
      SuiteId: suite.id,
      UserId: user.id,
      Role: user.roles[0].role.name,
      Signature: '',
      Status: statusToSet,
      homeownerId:
        suite.homeOwners && suite.homeOwners.id
          ? suite.homeOwners.id
          : suite?.homeownerId,
      ActionUrl:
        e.target.value === 'Guided Walk Through'
          ? 'app/suites/' + property.id + '&' + suite.id + '/openCalendly'
          : 'app/suites/' + property.id + '&' + suite.id,
    };
    let suiteData = suite;

    suiteData = { ...suite, status: statusToSet };

    this.setState({
      openModal: true,
      activateData: status,
      activateStatus: statusToSet,
    });
  }

  activateCall(SentEmail) {
    const { activateData, openModal } = this.state;
    const { suite, setWalkThroughStatus } = this.props;
    if (activateData.Status === 'Schedule' && !SentEmail)
      activateData.Status = 'Begin';
    let status = activateData;
    status = { ...activateData, SentEmail: SentEmail };
    let suiteData = suite;
    suiteData = { ...suite, status: activateData.Status };
    setWalkThroughStatus(status, suiteData);
    this.setState({ openModal: false });
  }

  convertToLocalTime(datestring) {
    let date = moment(datestring);
    if (date.isValid() || date.isAfter(moment()))
      return date.local().format('dddd MMM Do hh:mm A');
    return 'Booked';
  }

  statusView(data) {
    const { propertyManagerDetails } = this.props;
    if (
      data.walkthroughType === 'Simplified' ||
      data.walkthroughType === 'Developer Walk-through' ||
      data.walkthroughType === 'Construction Walk-through'
    )
      return (
        <SimplifiedStatusButton
          data={data}
          handleActivateWalkthrough={this.handleActivateWalkthrough}
        />
      );
    return (
      <StatusButton
        data={data}
        handleActivateWalkthrough={this.handleActivateWalkthrough}
        propertyManagerDetails={propertyManagerDetails}
      />
    );
  }

  onWalkthroughScheduled(data) {
    const { user, setWalkThroughStatus, suite, propertyManagerDetails } =
      this.props;
    const filteredWalkThrough = this.state.walkthroughSelectedObj;
    scheduleWalkthrough(data, {
      user,
      walkthroughId: filteredWalkThrough.id,
      propertyManagerDetails,
    });
    setTimeout(() => this.setState({ showOverlay: false }), 1000);

    let status = {
      walkthroughType: filteredWalkThrough.walkthroughType,
      WalkthroughId: filteredWalkThrough.id,
      SuiteId: suite.id,
      UserId: user.id,
      Role: user.roles[0].role.name,
      Signature: '',
      Status: 'Begin',
      PropertyName: propertyManagerDetails?.propertyName,
      SuiteName: suite.number,
      PropertymanagerId:
        propertyManagerDetails?.propertyManager &&
        propertyManagerDetails?.propertyManager?.id
          ? propertyManagerDetails?.propertyManager.id
          : '',
      ActionUrl:
        'app/suites/' + propertyManagerDetails?.propertyId + '&' + suite.id,
    };
    let suiteUpdateData = suite;
    suiteUpdateData = { ...suite, status: 'Begin' };
    setWalkThroughStatus(status, suiteUpdateData);
  }

  exportPDF = (data) => {
    if (data && data.pdfurl) {
      ToastInfo(SuccessMessages.pdfDownloadNotification);
      downloadDocument(data.pdfurl);
    }
  };
  handleActivateWalkthrough = (data, walkthroughType) => {
    const {
      suite,
      onSetPropertyWalkThroughFormIsVisible,
      property,
      onSetPropertyWalkThroughFormData,
      onSetPropertyWalkThroughFormStep,
      onFetchConfigureTypeWalkThroughData,
    } = this.props;
    const { activatedOptions, activateStatus } = this.state;
    return (
      <>
        Activate{' '}
        <div style={{ paddingLeft: 5 }}>
          <select
            selected={'Guided Walk Through'}
            value={activateStatus ? activateStatus : 'Select Walk Through Type'}
            style={{
              width: 16,
              border: 0,
              backgroundColor: 'rgba(255,255,255,0.1)',
            }}
            onChange={(e) =>
              suite.homeOwners && suite.homeOwners.id
                ? this.activate(e, data)
                : window.confirm(
                    'Do you want to continue without home owner assigned?'
                  ) && this.activate(e, data)
            }
          >
            <option disabled selected>
              {' '}
              Select Walk Through Type
            </option>
            {activatedOptions.map((item, i) => {
              return (
                <option value={item} key={i}>
                  {item}
                </option>
              );
            })}
          </select>
        </div>
        {/* https://app.asana.com/0/1208712340140532/1209872281262064/f */}
        {
          /*walkthroughType !== 'Simplified'*/ false && (
            <div
              style={{ marginLeft: 4 }}
              onClick={() => {
                onSetPropertyWalkThroughFormIsVisible(true);
                onSetPropertyWalkThroughFormData({
                  walkthroughType: data.walkthroughType,
                  propertyId: property.id,
                  propertyName: property.name,
                  suiteId: suite.id,
                  suiteName: variables.Suite + ' ' + suite.number,
                  assetWarrantyDefaultStartDate:
                    suite.assetWarrantyDefaultStartDate
                      ? suite.assetWarrantyDefaultStartDate
                      : null,
                  status: data.status,
                  walkthroughId: data.id ? data.id : '',
                  propertyAddress: property.addressLine1,
                  propertyCity: property.city,
                  propertyProvince: property.province,
                  proeprtyPostalCode: property.postalCode,
                });
                onSetPropertyWalkThroughFormStep(2);
                onFetchConfigureTypeWalkThroughData(data.id);
              }}
            >
              Edit
            </div>
          )
        }
      </>
    );
  };
  deleteWalkthrough = (data) => {
    const { user, onDeleteWalkthrough } = this.props;
    onDeleteWalkthrough(data.id, user.id, data.suiteId);
  };

  render() {
    const {
      suite,
      search,
      walkThroughs,
      onSearch,
      propertyManagerDetails,
      onFetchAvailableServiceTimes,
      availableServiceTimes,
      user,
      pdfloader,
    } = this.props;
    const { showOverlay, addWalkthroughVisible, openModal } = this.state;

    return (
      <>
        {pdfloader && <Loader center={true} />}
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Walkthroughs..."
            onChange={onSearch}
          />
          {!onCheckUserCanAccessTheModule([
            USER_ROLES.HOME_OWNER,
            USER_ROLES.OCCUPANT,
            USER_ROLES.REALTOR,
          ]) && (
            <Button
              color="teal"
              label="Add Walkthrough"
              onClick={() => this.setState({ addWalkthroughVisible: true })}
              icon={
                <FontAwesomeIcon glyph="plus" weight="light" size="small" />
              }
              size="small"
            />
          )}
        </Actions>
        {walkThroughs.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: 'Walk Through Type',
                  accessor: 'name',
                  cell: (data) => (
                    <>
                      <div
                        title={
                          data.walkthroughType === 'Simplified' ||
                          data.walkthroughType === 'Enhanced'
                            ? data.walkthroughName
                            : data.walkthroughType
                        }
                      >
                        {data.walkthroughType === 'Simplified' ||
                        data.walkthroughType === 'Enhanced'
                          ? data.walkthroughName
                          : data.walkthroughType}
                      </div>
                    </>
                  ),
                },
                {
                  label: 'Status',
                  accessor: 'name',
                  cell: (data) =>
                    user.roles[0].role.name !== 'Realtor' ? (
                      <div
                        className="walkThroughTable__status"
                        style={{
                          display: 'flex',
                          justifyContent: 'left',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.handleStatusClicked(data)}
                      >
                        <div
                          className="walkThroughTable__status"
                          style={{ display: 'flex' }}
                        >
                          {this.statusView(data)}
                        </div>
                      </div>
                    ) : user.roles[0].role.name === 'Realtor' &&
                      data.status === 'Review' ? (
                      <div
                        className="walkThroughTable__status"
                        style={{
                          display: 'flex',
                          justifyContent: 'left',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.handleStatusClicked(data)}
                      >
                        <div
                          className="walkThroughTable__status"
                          style={{ display: 'flex' }}
                        >
                          {this.statusView(data)}
                        </div>
                      </div>
                    ) : null,
                },
                {
                  xsHide: true,
                  label: 'Description',
                  accessor: 'description',
                  cell: (data) => (
                    <div title={data.description}>{data.description}</div>
                  ),
                },
                {
                  center: true,
                  xsHide: true,
                  label: 'Issues Logged',
                  accessor: 'serviceRequestCount',
                },
                {
                  center: true,
                  label: 'Export to PDF',
                  cell: (data) =>
                    data && data.pdfurl ? (
                      <div className="walkThroughTable__status">
                        <a
                          onClick={() => this.exportPDF(data)}
                          style={{ color: 'inherit', cursor: 'pointer' }}
                        >
                          {' '}
                          <FontAwesomeIcon
                            glyph="download"
                            weight="light"
                          />{' '}
                          Export
                        </a>
                      </div>
                    ) : (
                      'N/A'
                    ),
                },
                {
                  // hide: true,
                  cell: (data) =>
                    onCheckUserCanAccessTheModule([
                      USER_ROLES.PROPERTY_DEVELOPER,
                      USER_ROLES.ADMIN,
                      USER_ROLES.SUPER_ADMIN,
                      USER_ROLES.STRATA_MANAGER,
                    ]) && (
                      <Hidden style={{ cursor: 'pointer' }}>
                        <Button
                          color="semantic"
                          label={
                            <FontAwesomeIcon glyph="trash" weight="light" />
                          }
                          onClick={() => {
                            window.confirm(
                              `Are you sure you want to delete ${data.walkthroughName}?`
                            ) && this.deleteWalkthrough(data);
                          }}
                        />
                      </Hidden>
                    ),
                },
              ]}
              data={walkThroughs}
            />
          </>
        ) : (
          <Empty
            headline="No Walkthroughs yet"
            strapline="All Walkthroughs will be listed here so it’s easier for you to manage."
            searchIsActive={
              search && search.walkThrough ? search.walkThrough : ''
            }
            image={
              <img alt="No Walk Throughs yet" src="/assets/empty/suites.svg" />
            }
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <ScheduleWalkthroughComponent
              suite={suite}
              property={propertyManagerDetails}
              scheduling_url={propertyManagerDetails?.calendlyLink}
              hasCalendlyKey={
                propertyManagerDetails?.calendlyAPIKey ? true : false
              }
              onEventScheduled={(data) => {
                this.onWalkthroughScheduled(data);
              }}
              onClose={() => {
                this.setState({ showOverlay: false });
              }}
              onFetchAvailableServiceTimes={onFetchAvailableServiceTimes}
              availableServiceTimes={availableServiceTimes}
              user={user}
            />
          }
        />
        <Overlay
          showOverlay={addWalkthroughVisible}
          content={
            <AddWalkthrough
              suiteId={suite.id}
              userId={user.id}
              roleName={user.roles[0].role.name}
              onClose={() => {
                this.setState({ addWalkthroughVisible: false });
              }}
            />
          }
        />
        {openModal && (
          <div className="custom_popup" ref={this.setWrapperRef}>
            <div className="custom_inside_popup">
              <div style={{ textAlign: 'right' }}>
                <div style={{ textAlign: 'right' }}>
                  <div className="filters_modal_top_coner_box">
                    <div
                      className="filters_modal_close_icon"
                      onClick={() =>
                        this.setState({
                          openModal: false,
                          activateStatus: 'Select Walk Through Type',
                        })
                      }
                    >
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'center', paddingBottom: 2 }}>
                Would you like to send the walkthrough notification and
                scheduling email to the homeowner?
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  alignItems: 'center',
                  padding: 20,
                }}
              >
                <Button
                  color="teal"
                  label="Send EMail"
                  size="tiny"
                  onClick={() => this.activateCall(true)}
                />
                <Button
                  color="teal"
                  label="Don`t send EMail"
                  size="tiny"
                  onClick={() => this.activateCall(false)}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
  propertyWalkThroughFormIsVisible:
    selectPropertyWalkThroughFormIsVisible(state),
  availableServiceTimes: state.availableServiceTimes,
  pdfloader: selectFormLoader(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchCalendlyLink: fetchCalendlyLink,
      onSetSuiteFormData: setSuiteFormData,
      onClearSuiteFormData: clearSuiteFormData,
      onSetPropertyWalkThroughFormIsVisible:
        setPropertyWalkThroughFormIsVisible,
      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
      onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,
      onFetchConfigureTypeWalkThroughData: fetchConfigureTypeWalkThroughData,
      onExitEasyWalkThroughForm: exitEasyWalkThroughForm,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onfetchAssetsBySuiteId: fetchAssetsBySuiteId,
      onEventScheduled,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      setWalkThroughStatus,
      onFetchWalkThroughServiceList: fetchWalkThroughServiceList,
      onFetchAllIssueTypes: fetchAllIssueTypes,
      onWalkthroughScheduled,
      onFetchAvailableServiceTimes: fetchPropertyDeveloperAvailableTimes,
      startFormLoading,
      stopFormLoading,
      onDeleteWalkthrough: onDeleteWalkthrough,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(WalkThroughTable);
